import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class CrudService {
  ENV = environment.apiUrl;
  ENV_LOCAL = environment.apiUrlLocal;

  constructor(private http: HttpClient) {}

  getLocal(endPointUrl: string, Options?: any): Observable<any> {
    return this.http.get(this.ENV_LOCAL + endPointUrl, Options);
  }

  get(endPointUrl: string, Options?: any): Observable<any> {
    return this.http.get(this.ENV + endPointUrl, Options);
  }
  post(endPointUrl: string, body?: any, options?: any): Observable<any> {
    return this.http.post(this.ENV + endPointUrl, body, options);
  }
  delete(endPointUrl: string, Options?: any): Observable<any> {
    return this.http.delete(this.ENV + endPointUrl, Options);
  }
  update(endPointUrl: string, Options?: any): Observable<any> {
    return this.http.patch(this.ENV + endPointUrl, Options);
  }
}
